require(["jquery", "contactUsForm", "menuHelper", "kendoInlineScripts", "uiNotification", "signout", "session", "userTrackingHelper", "antiForgeryTokenHelper", "utility"],
    function ($, contactUsForm, menuHelper, kendoInlineScripts, uiNotification, signout, session, userTrackingHelper, antiForgeryTokenHelper, utility) {

    $(function() {

        var baseUrl = getBaseUrl();

        signout.init();
        //session.init();
        uiNotification.init();
        displayServiceRequestsForPartner(baseUrl, getAgentUids());

        var merchantUID = $("#hiddenMerchantUID").val();

        $("#menuhambuger").toggle($("#sidebar").length > 0);

        if (merchantUID.length !== 0) {
            countAlert(baseUrl, merchantUID);
        }

        var isMerchant = $("#isMerchant").val();
        if (isMerchant == "True" && merchantUID.length !== 0) {          
            displayMerchantList(baseUrl, merchantUID);
        }
        else if (merchantUID.length !== 0) {
            displayDbaName(baseUrl, merchantUID);
            setTimeout(adjustHeaderCss(), 1000);
        }
        addAmplitudeInfoToLocalStorage();

        $("#btnAlertCount").on("click", function(e) {
            window.location.href = baseUrl + 'Merchants/' + merchantUID + '/Alert';
            e.preventDefault();
        });

        $("#logoutForm").on("click", function(e) {
            e.preventDefault();
            cleanAmplitudeInfoFromLocalStorage();
            signout.initiate("");
        });

        $("#oAuthGoBack").on("click", function(e) {
            e.preventDefault();
            cleanAmplitudeInfoFromLocalStorage();
            signout.initiate("OAuth");
        });
        
        if (merchantUID.length !== 0) {
            displayServiceRequestsForMerchant(baseUrl, merchantUID);
        }

        // Top Right User Menu
        $("#loginSidebar").kendoMenu();
        $("#loginSidebar").show();
        var icon = $("#loginSidebar").find(".k-icon");
        if (icon.length !== 0) {
            icon.removeClass("k-icon k-i-arrow-s");
        }
       
        $(window).on("resize", function() {
            adjustHeaderCss();
        });

        $(window).on("orientationchange", function() {
            adjustHeaderCss();  
        });

        function doOnOrientationChange() {
            adjustHeaderCss(); 
        }

        window.addEventListener("orientationchange", doOnOrientationChange);

        menuHelper.init();
        hideMerchantDashboardTourBtn(merchantUID);

        notifyServiceRequestNotAvailable();
        
    });

    function addAmplitudeInfoToLocalStorage() {
        var userUId = utility.safeLocalStorage.getItem("UserUID");
        var userType = utility.safeLocalStorage.getItem("UserType");
        if (userUId === 'undefined' || userUId === null || userUId === '') {
            var newUserUId = $('#hiddenEncryptedUserUId').val();
            if (newUserUId !== 'undefined' && newUserUId !== null && newUserUId !== '') {
                utility.safeLocalStorage.setItem("UserUID", newUserUId);
            }
        }
        if (userType === 'undefined' || userType === null || userType === '') {
            var newUserType = $('#hiddenAmplitudeUserType').val();
            if (newUserType !== 'undefined' && newUserType !== null && newUserType !== '') {
                utility.safeLocalStorage.setItem("UserType", newUserType);
            }
        }
    }
        function cleanAmplitudeInfoFromLocalStorage() {
        var userUId = utility.safeLocalStorage.getItem("UserUID");
        var userType = utility.safeLocalStorage.getItem("UserType");
        if (userUId !== 'undefined' && userUId !== null) {
            localStorage.removeItem("UserUID");
        }
        if (userType !== 'undefined' || userType !== null) {
            localStorage.removeItem("UserType");
        }
    }

    function getAgentUids() {
        var guidList = $('#hiddenAgentUIDs').val();
        if (guidList == undefined || guidList.length === 0) {
            return null;
        }

        guidList = guidList.split('|');

        var guids = [];

        $.each(guidList, function() {
            if (isGuidFormat(this)) {
                guids.push(this);
            }
    });
    
        return guids;
    }

    function isGuidFormat(str) {
        if (str[0] === "{") {
            str = str.substring(1, str.length - 1);
        }
        var regexGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return regexGuid.test(str);
    }


    function getBaseUrl() {
        var path = location.href.split("/");
        var protocol = path[0];
        var host = path[2];
        return protocol + '//' + host + '/';
    };

    function displayDbaName(baseUrl, merchantUID) {
        $.ajax({
            url: baseUrl + 'api/Dashboard/DBAName?merchantUID=' + merchantUID,
            method: "GET",
            headers: { 'RequestVerificationToken': antiForgeryTokenHelper.getAntiForgeryToken() }
        }).success(function (data) {
            if (typeof data != 'undefined' && data) {
                var lastFour = data.substr(data.length - 4);
                var name = data.substr(0, data.length - 4);
                $(".business-name").html(name + "<div>Merchant #XXXXXXXXXXXX " + lastFour + "</div>");
            }
        });
    };

    function countAlert(baseUrl, merchantUID) {
        var alertSummaryUrl = baseUrl + 'api/' + merchantUID + '/AlertSummary';
        var allAlertUrl = baseUrl + 'Merchants/' + merchantUID + '/Alert';
        var alertMessages = $("<div>");

        $.ajax({
            url: alertSummaryUrl,
            method: "GET",
            headers: { 'RequestVerificationToken': antiForgeryTokenHelper.getAntiForgeryToken() }
        }).success(function(result) {
            if (typeof result != 'undefined' && result != null) {
                if (typeof result.RecentAlertMesg != 'undefined') {
                    $.each(result.RecentAlertMesg,
                        function(idx, elm) {
                            alertMessages.append("<p>" + elm + "</p>");
                        });
                    alertMessages.append("<a href ='" + allAlertUrl + "'>View all</a>");
                }
                if (typeof result.ActiveAlertsCount != 'undefined' && result.ActiveAlertsCount > 0) {
                    $("#btnAlertCount").append("<span id='alertCount'>" + result.ActiveAlertsCount + "</span>");
                    $("#btnAlertCount").kendoTooltip({
                        content: alertMessages,
                        width: 200,
                        autoHide: false
                    });
                }
            }
        });
    }

    function displayMerchantList(baseUrl, merchantUID) {
        $.ajax({
            url: baseUrl + "api/Dashboard/MerchantList",
            method: "GET",
            headers: { 'RequestVerificationToken': antiForgeryTokenHelper.getAntiForgeryToken() }
        }).success(function(result) {
            if (result.length > 1) {
                var i = findIndexInArrayObject(result, merchantUID);

                var data = { Result: result, CurrentMerchantIndex: i, Length: result.length > 10 ? 10 : result.length };
                var lnkMerchantsTemplate = kendo.template($("#header-lnkMerchants-template").html());
                var lnkMerchantsHtmlContent = lnkMerchantsTemplate(data);
                $("#lnkMerchantsMenu").html(lnkMerchantsHtmlContent);
                
                //$("#lnkMerchantsMenu").kendoMenu();
            }
            else if (result.length === 1) {
                $(".business-name").html(result[0].DbaName + "<div class='lnkMerchantNum'>Merchant #XXXXXXXXXXXX " +
                    result[0].MerchantNumber.substr(result[0].MerchantNumber.length - 4) + "</div>");
            }

            setTimeout(adjustHeaderCss(), 1000);
        });
    }
            
    function displayServiceRequestsForMerchant(baseUrl, merchantUid) {
        if (merchantUid === undefined || merchantUid === null || merchantUid.length === 0) {
            return;
        }
        $.ajax({
            url: baseUrl + "api/Merchants/" + merchantUid + "/ServiceRequest/AccessAllowed",
            method: "GET",
            headers: { 'RequestVerificationToken': antiForgeryTokenHelper.getAntiForgeryToken() }
        }).done(function(data) {
            toggleMerchantServiceRequestIcon(data);
        }).fail(function(data, textStatus, errThrown) {
            toggleMerchantServiceRequestIcon("false");
        });
    }

    function displayServiceRequestsForPartner(baseUrl, agentUids) {
        if (agentUids === undefined || agentUids === null || agentUids.length === 0) {
            return;
        }
        $.ajax({
            url: baseUrl + "api/Agents/ServiceRequest/AccessAllowed",
            method: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify(agentUids),
            headers: { 'RequestVerificationToken': antiForgeryTokenHelper.getAntiForgeryToken() }
        }).done(function(data) {
            togglePartnerServiceRequestIcon(data);
        }).fail(function(data, textStatus, errThrown) {
            togglePartnerServiceRequestIcon("false");
        });
    }

    function toggleMerchantServiceRequestIcon(show) {
        if (show === true) {
            $("#sidebar-merchantservicerequests").show();
            $("#sidebar-contactUs").hide();
        }
        else {
            $("#sidebar-merchantservicerequests").hide();
            $("#sidebar-contactUs").show();
        }
    }

    function notifyServiceRequestNotAvailable(){
        $("#sidebar-merchantservicerequests a.lnkDisabled").on("click", function (e) {
            e.preventDefault();
            uiNotification.notify("We are setting everything up, and it may take up to 2 hours. Please come back later.", "info");
        });
    }

    function togglePartnerServiceRequestIcon(show) {
        if (show === true) {
            $("#sidebar-partnerservicerequests").show();
        }
        else {
            $("#sidebar-partnerservicerequests").hide();
        }
    }

    function findIndexInArrayObject(array, valueToSearch) {
        for (var i = 0; i < array.length; i++) {
            if (array[i].MerchantUID == valueToSearch) {
                return i;
            }
        }
        return 0;
    }

    function adjustHeaderCss() {
        var leftWidth = $(".left").width();
        var rightWidth = $(".right").width();
        var headerWidth = $("header").width();
        var logoWidth = headerWidth - leftWidth - rightWidth;

        var imageWidth = getImageSize("brandingLogo").width;
        if (imageWidth > logoWidth && headerWidth <= 1024) {
            $(".centered").hide();
            return;
        }
        logoWidth = imageWidth;

        var centerWidth = (headerWidth - leftWidth - rightWidth) > 500 ? (500 > logoWidth ? logoWidth : 500)
                            : ((headerWidth - leftWidth - rightWidth) > logoWidth ? logoWidth : (headerWidth - leftWidth - rightWidth));

        $(".centered").css("width", centerWidth + "px");
        var imgMargin = (headerWidth - centerWidth) / 2;
        if (imgMargin < leftWidth || imgMargin < rightWidth) {
            $(".centered").hide();
            return;
        }

        $(".centered").show();

    }

    function getImageSize(element) {
        if (document.getElementById(element) === null) return { width: 0, height: 0 };
        var naturalWidth = document.getElementById(element).naturalWidth;
        var naturalHeigth = document.getElementById(element).naturalHeight;
        var headerHight = 65;     
        if (naturalWidth > 500) {
            var height = 500 / naturalWidth * naturalHeigth;
            return { width: 500, height: height };
        }
        else {
            var width = naturalWidth * headerHight / naturalHeigth;
            return { width: width, height: headerHight };
        }
    };

    function hideMerchantDashboardTourBtn(merchantUid) {
        if (merchantUid === undefined || merchantUid === null || merchantUid.length === 0) {
            $("#merchantDashboardTourBtn").hide();
        }
        else {
            var path = location.href.split("/");
            if (!(path[3].toLowerCase() == "merchants" && path[5].toLowerCase() == "dashboard")) {
                $("#merchantDashboardTourBtn").hide();
            }            
        }
    } 

})
